export * from './extrema.model';
export * from './extrema.creator';
